import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-arrow_left",
  "use": "rt-portal-arrow_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-arrow_left\"><defs><style type=\"text/css\"></style></defs><path d=\"M272.448 472.064l399.232-399.232c22.08-22.08 57.792-22.08 79.872 0 22.016 22.016 22.08 57.792 0 79.872l-359.296 359.296 359.296 359.296c22.016 22.016 22.08 57.792 0 79.872s-57.792 22.016-79.872 0l-399.232-399.232c-22.016-22.08-22.016-57.792 0-79.872z\" p-id=\"4392\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/arrow_left.svg
// module id = 679
// module chunks = 99